// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoContainer_container__7WeRz","title":"VideoContainer_title__fOP7_","wrapper":"VideoContainer_wrapper__Pkf43","item":"VideoContainer_item__JSTl4"};